module.exports = __webpack_public_path__ + "img/sdk-white.4bec4d51.svg";